import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  disabled = false,
  loading = false,
  icon: Icon = null,
  className = '',
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-bold rounded-2xl transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-offset-2 shadow-lg relative overflow-hidden group';
  
  const variants = {
    primary: 'bg-gradient-to-r from-red-500 via-red-600 to-red-500 text-white hover:shadow-2xl hover:shadow-red-500/50 focus:ring-red-500/50 hover:scale-105',
    secondary: 'bg-gradient-to-r from-gray-100 to-gray-200 text-gray-800 hover:from-gray-200 hover:to-gray-300 hover:shadow-xl focus:ring-gray-500/50',
    outline: 'bg-white border-2 border-red-500 text-red-600 hover:bg-gradient-to-r hover:from-red-50 hover:to-red-100/50 hover:border-red-600 hover:shadow-xl hover:shadow-red-500/20 focus:ring-red-500/50',
    danger: 'bg-gradient-to-r from-rose-500 to-rose-600 text-white hover:shadow-2xl hover:shadow-rose-500/50 focus:ring-rose-500/50 hover:scale-105',
    success: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white hover:shadow-2xl hover:shadow-green-500/50 focus:ring-green-500/50 hover:scale-105',
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  const disabledClasses = disabled || loading ? 'opacity-60 cursor-not-allowed saturate-50' : '';

  return (
    <motion.button
      whileHover={!disabled && !loading ? { scale: 1.05, y: -2 } : {}}
      whileTap={!disabled && !loading ? { scale: 0.95 } : {}}
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${className}`}
      {...props}
    >
      {loading ? (
        <div className="w-5 h-5 border-3 border-white border-t-transparent rounded-full animate-spin mr-2" />
      ) : Icon ? (
        <Icon className="w-5 h-5 mr-2" />
      ) : null}
      {children}
    </motion.button>
  );
};

export default Button;

